import Swiper from 'swiper/bundle';

class PetCourseItems {
  constructor() {
    this.wrapper = document.querySelector("[data-role='pet-course-items']");

    if (!this.wrapper) return;

    this.swiperElm = this.wrapper.querySelector("[data-role='pet-course-swiper']");
    this.swiperNext = this.wrapper.querySelector("[data-role='pet-course-swiper-next']");
    this.swiperPrev = this.wrapper.querySelector("[data-role='pet-course-swiper-prev']");

    if (!this.swiperElm || !this.swiperNext || !this.swiperPrev) return;

    this.swiper = null;
    this.originalHTML = this.swiperElm.innerHTML; // 元のHTMLを保存
    this.initSwiper();
    this.handleResize();
  }
  
  initSwiper() {
    if (window.innerWidth >= 768) {
      // 必要なクラスを再適用
      this.swiperElm.classList.add('swiper', 'swiper-initialized');
      const slides = this.swiperElm.children;
      Array.from(slides).forEach((slide) => slide.classList.add('swiper-slide'));

      // Swiperを初期化
      this.swiper = new Swiper(this.swiperElm, {
        slidesPerView: 1.8,
        spaceBetween: 32,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: this.swiperNext,
          prevEl: this.swiperPrev,
        },
      });
    }
  }

  destroySwiper() {
    if (this.swiper !== null) {
      // Swiperインスタンスの破棄
      this.swiper.destroy(true, true);
      this.swiper = null;

      // HTMLを元の状態に戻す
      this.swiperElm.innerHTML = this.originalHTML;

      // 不要なクラスを削除
      const swiperClasses = ['swiper', 'swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden'];
      swiperClasses.forEach((cls) => {
        this.swiperElm.classList.remove(cls);
      });
    }
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth < 768 && this.swiper !== null) {
          this.destroySwiper();
        } else if (window.innerWidth >= 768 && this.swiper === null) {
          this.initSwiper();
        }
      }, 150);
    });
  }
}

export default PetCourseItems;
